// services/abandonedCartService/rpcFallback.ts - save.ts split (sub-module RPC fallback)

import type { SaveCartParams } from './types.js';

// Fallback: import supabase hanya saat dibutuhkan (dynamic import)
export async function saveViaSupabaseRPC(params: SaveCartParams): Promise<{ id: string; action: string } | null> {
  try {
    const { supabase } = await import('../../supabase');
    const { cartId: rawCartId, ...cartData } = params;
    const payload = {
      formTitle: cartData.formTitle || '',
      brandId: cartData.brandId || null,
      customerName: cartData.customerName || 'Unknown',
      customerPhone: cartData.customerPhone || '',
      customerEmail: cartData.customerEmail || '',
      selectedVariant: cartData.selectedVariant || 'Produk Tunggal',
      totalPrice: cartData.totalPrice || 0,
      status: cartData.status || 'New',
      source_type: cartData.source_type || 'form_order',
      productId: cartData.productId || null,
      formId: cartData.formId || null,
      assigned_cs_id: cartData.assigned_cs_id || null,
      utmSource: cartData.utmSource || '',
      utmMedium: cartData.utmMedium || '',
      utmCampaign: cartData.utmCampaign || '',
      utmTerm: cartData.utmTerm || '',
      utmContent: cartData.utmContent || '',
      timestamp: new Date().toISOString(),
      // productSlug digital hanya ada top-level — selipkan ke cart_data (RPC
      // hanya baca cart_data utk link reminder; tanpa ini fallback = no_link).
      cart_data: { ...((cartData.cart_data || cartData.cartData || {}) as any), ...((cartData as any).productSlug ? { productSlug: (cartData as any).productSlug } : {}) },
    };
    const { data: result, error: rpcError } = await (supabase as any).rpc('upsert_abandoned_cart', {
      p_cart_id: rawCartId || null,
      p: payload,
    });
    if (rpcError) {
      console.warn('[AbandonedCart] Fallback RPC error:', rpcError);
      return null;
    }
    // RPC baru kembalikan {id, action}; versi lama kembalikan id string — toleran dua-duanya.
    if (result && typeof result === 'object') {
      if (!result.id) return null;
      return { id: String(result.id), action: result.action === 'inserted' ? 'created' : 'updated' };
    }
    return { id: result || '', action: rawCartId ? 'updated' : 'created' };
  } catch (err) {
    console.warn('[AbandonedCart] Fallback gagal:', err);
    return null;
  }
}
